import * as React from 'react';
import PropTypes from 'prop-types';
import { TextField, MenuItem, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import styles from './HB1416SessionLog.styles';

const SUBJECTS = [
  { value: 'math', label: 'Math' },
  { value: 'reading', label: 'Reading' },
];

const todayISO = () => new Date().toISOString().slice(0, 10);

const emptyForm = () => ({
  date: todayISO(),
  minutes: '',
  subject: 'math',
  provider: '',
  note: '',
});

class HB1416SessionLog extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    firebaseId: PropTypes.string.isRequired,
    snapshotYear: PropTypes.string,
    sessions: PropTypes.array,
    onLogSession: PropTypes.func.isRequired,
  };

  static defaultProps = {
    sessions: [],
  };

  state = { form: emptyForm() };

  handleChange = (field) => (event) => {
    const { value } = event.target;
    this.setState((prev) => ({ form: Object.assign({}, prev.form, { [field]: value }) }));
  };

  isValid = () => {
    const { date, minutes, subject } = this.state.form;
    const mins = Number(minutes);
    return Boolean(date) && Boolean(subject) && Number.isFinite(mins) && mins > 0;
  };

  handleSave = () => {
    if (!this.isValid()) return;
    const { firebaseId, snapshotYear, onLogSession } = this.props;
    const { form } = this.state;
    const session = {
      date: form.date,
      minutes: Number(form.minutes),
      subject: form.subject,
      provider: form.provider || '',
      note: form.note || '',
    };
    onLogSession(snapshotYear, firebaseId, session);
    this.setState({ form: emptyForm() });
  };

  render() {
    const { classes, sessions } = this.props;
    const { form } = this.state;
    return (
      <div className={classes.root}>
        <div className={classes.sectionTitle}>Session Log</div>
        {sessions && sessions.length > 0 ? (
          <div className={classes.sessionList}>
            {sessions.map((session, index) => (
              <div className={classes.sessionRow} key={`${session.date}-${index}`}>
                <span className={classes.sessionDate}>{session.date}</span>
                <span className={classes.sessionMeta}>
                  {session.minutes} min · {session.subject}
                  {session.provider ? ` · ${session.provider}` : ''}
                  {session.note ? <span className={classes.sessionNote}> — {session.note}</span> : null}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className={classes.emptyState}>No sessions logged yet.</div>
        )}
        <div className={classes.form}>
          <TextField
            className={classes.field}
            label="Date"
            type="date"
            value={form.date}
            onChange={this.handleChange('date')}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            className={classes.field}
            label="Minutes"
            type="number"
            value={form.minutes}
            onChange={this.handleChange('minutes')}
            inputProps={{ min: 1 }}
          />
          <TextField
            className={classes.field}
            select
            label="Subject"
            value={form.subject}
            onChange={this.handleChange('subject')}
          >
            {SUBJECTS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            className={classes.field}
            label="Provider"
            value={form.provider}
            onChange={this.handleChange('provider')}
          />
          <TextField
            className={classes.noteField}
            label="Note"
            value={form.note}
            onChange={this.handleChange('note')}
          />
          <Button
            className={classes.saveButton}
            variant="contained"
            color="primary"
            disabled={!this.isValid()}
            onClick={this.handleSave}
          >
            Log Session
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(HB1416SessionLog);
